import React from "react";
import { NavLink } from "react-router-dom";
import { GameImage } from './GameImage.jsx';


export class GameSmall extends React.Component {

    constructor(props) {
        super(props);
    }

    createGoogleTagEvent() {
        document.body.classList.add("no-scroll");
        let kategorijeArray = [];

        if (this.props.categories) {
            Object.keys(this.props.igra.kt).forEach(key => {
                const filterKategorija = this.props.categories.find(x => x.id == key);
                if (filterKategorija)
                    kategorijeArray.push(filterKategorija.name);
            });

            casino.utils.createGoogleTagManagerEvent({
                'event': 'game_click',
                'game_name': this.props.igra.n,
                'game_provider': this.props.brands[this.props.igra.bID].name,
                'game_type': kategorijeArray ? kategorijeArray.join() : '',
                'jackpot': this.props.igra.jp ? 'yes' : 'no',
                'jackpot_amount': this.props.igra.jp ? this.props.igra.jp : 0,
                'gameId': this.props.igra.id
            });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return false;
    }

    render() {
        let maintenanceClass = this.props.igra && this.props.igra.p && (this.props.igra.p.indexOf("o") != -1) ? 'maintenance ' : '';

        var game = this.props.igra;
        

        return <NavLink
            onClick={() => this.createGoogleTagEvent()}
            to={{
                pathname: ((this.props.routePrefix || '') + '/').replace('//', '/') + 'game/' + this.props.brands[this.props.igra.bID].nameNormalizirano + "/" + casino.utils.normalizeString(this.props.igra.n),
                query: {
                    game: casino.utils.normalizeString(this.props.igra.n), from: (this.props.from || ''),
                    // GamePosition podaci, HizmanB
                    PageName: this.props.PageName,
                    GamePosition: this.props.GamePosition,
                    PositionType: this.props.PositionType,
                    ComponentName: this.props.ComponentName,
                    ComponentPosition: this.props.ComponentPosition,
                    IsIcon: this.props.IsIcon,
                    TabName: this.props.TabName,
                    TabPosition: this.props.TabPosition,
                    SliderName: this.props.SliderName,
                    SliderPosition: this.props.SliderPosition
                }

            }} className={'game-item-small relative ' + maintenanceClass + this.props.extraClass}>

            <GameImage brands={this.props.brands} iconImage={this.props.iconImage} goLazyImage={this.props.goLazyImage} igra={this.props.igra} showJackpot={this.props.showJackpot} showNovo="false" routePrefix={this.props.routePrefix} categories={this.props.categories} isVerticalImage={this.props.isVerticalImage}></GameImage>

                {this.props.dobitak && <div className={"dobitak-iznos pull-up"}>
                    <div className="iznos text-ellipsis">
                        {casino.utils.numberWithCurrencyFromated(this.props.dobitak, this.props.valuta)}
                    </div>
                </div>}

                {this.props.showGameName && <div className="relative">
                    <span className={'game-name ' + (this.props.gameNameClass || '')}>
                        {this.props.igra.n}
                    </span>

                    {this.props.showRtp && <div className={"rtp-value " + (this.props.igra.rtp > 100 ? 'hot' : 'cold')}>
                        {this.props.igra.rtp}%
                    </div>}

                    {this.props.showJackpot && this.props.igra.jp && <div className="game-jackpot"></div>}
                </div>}

                {!this.props.showGameName && this.props.showJackpot && this.props.igra.jp && <div className="relative jackpot-badge">
                    <div className="game-jackpot"></div>
                </div>}

                {this.props.showJackpotValue && <div className="relative">
                    {this.props.igra.jp > 0 && <span className={'game-name  game-jackpot-value'}>
                        {casino.utils.numberWithCurrencyFromated(this.props.igra.jp, this.props.igra.v)}
                    </span>}
                    {this.props.igra.jp <= 0 && <span className={'game-name  game-jackpot-value game-jackpot-value-istrazi'}>
                        ISTRAŽI
                    </span>}
                </div>}

                {this.props.dobitak && <div className="text text-ellipsis text-27 text-center"> {this.props.igra.n}
                </div>}

                {this.props.dobitak && <div className="text text-34 margin-bottom-xsmall text-center"> {casino.utils.dateToFullDateString(new Date(this.props.datum))}
                </div>}
            </NavLink>
    }
};
